import Colors from "assets/Colors";
import { Rect, Text, Group, Image, Transformer } from "react-konva";
import useImage from "use-image";
import Pen from "assets/iconsSvg/pen.svg";
import React, { useState } from "react";

function getTextWidth(text, fontSize) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = `${fontSize}px Arial, sans-serif`;
  context.font = `500 ${context.font}`;
  return context.measureText(text).width;
}

const margin = 2;

const Tables = ({
  shapeProps,
  isSelected,
  editing,
  setAddTableModalOpen,
  setEditingTable,
  onSelect,
  handleDragEnd,
  index,
  onChange,
  dragBoundFunc,
}) => {
  const [pen] = useImage(Pen);

  const [isDraggable, setIsDraggable] = useState(false);
  const [isTransformer, setIsTransformer] = useState(false);

  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const x = parseInt(shapeProps.posX);
  const y = parseInt(shapeProps.posY);
  const width = parseInt(shapeProps.width);
  const height = parseInt(shapeProps.height);
  // const rotation = parseInt(shapeProps.rotation);

  const truncatedText =
    shapeProps.name.length > 10
      ? `${shapeProps.name.slice(0, 9)}...`
      : shapeProps.name;

  return (
    <Group onTap={onSelect} key={shapeProps._id}>
      <Rect
        x={x + margin}
        y={y + margin}
        width={width - margin * 2}
        height={height - margin * 2}
        onClick={editing && onSelect}
        onTap={onSelect}
        fill="#fff"
        draggable={editing}
        ref={shapeRef}
        stroke={Colors.icon_secondary}
        strokeWidth={0}
        shadowBlur={1}
        cornerRadius={
          shapeProps.type === "circle" ? Math.min(width, height) / 2 : 5
        }
        onDragStart={() => {
          setIsDraggable(true);
        }}
        onDragEnd={(event) => {
          setIsDraggable(false);
          handleDragEnd(index, event, "tables");
        }}
        dragBoundFunc={(pos) => dragBoundFunc(pos, width, height)}
        onTransformStart={() => {
          setIsTransformer(true);
        }}
        onTransformEnd={() => {
          setIsTransformer(false);
          const node = shapeRef.current;
          // const rotation = node.rotation();
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            posX: node.x(),
            posY: node.y(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
            // rotation: rotation,
          });
        }}
      />

      {editing && !isDraggable && !isTransformer && (
        <Image
          image={pen}
          x={
            shapeProps.type === "circle" ? x + width / 2 - 7.5 : x + width - 17
          }
          y={shapeProps.type === "circle" ? y + 2 : y + 5}
          width={15}
          height={15}
          onClick={() => {
            setAddTableModalOpen(true);
            setEditingTable(shapeProps);
          }}
        />
      )}

      {!isDraggable && !isTransformer && (
        <>
          <Text
            text={truncatedText}
            x={x + width / 2 - getTextWidth(truncatedText, 12) / 2}
            y={y + height - 12 - height / 2}
            fill={Colors.text_primary}
            fontSize={12}
            align="center"
            fontStyle="500"
          />
          <Text
            text={`(${shapeProps.capacity}p)`}
            x={
              x + width / 2 - getTextWidth(`(${shapeProps.capacity}p)`, 12) / 2
            }
            y={y + height - 12 - height / 3.5}
            fill={Colors.text_primary}
            fontSize={12}
            align="center"
            fontStyle="500"
          />
        </>
      )}

      {isSelected && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          rotateEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </Group>
  );
};

export default Tables;
